<template>
  <div class="login">
    <el-card class="box-card">
      <img src="@/assets/登录背景.jpg" alt />

      <el-form ref="form" :model="form">
        <h2>欢迎登录</h2>
        <el-form-item label="工号" placeholder="请输入工号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" placeholder="请输入密码">
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="onSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
/**
 * 我有个基本的想法，不知道可不可行。
 * 1. 点击百科的链接的时候，你们前端给你们后端发个请求GetFreshWikiUserSession.
 * 2. 你们接到这个请求的时候，获取session里保存的OA账号信息，然后使用这个来登录生鲜百科，返回的信息里面带有Session。
 * 3. 你们返回给前端，然后带到链接地址里，开始跳转过来。
 * 4. 我把跳转里携带的Session信息写入Cookie，这个时候就不需要再登录了。
 */
export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async onSubmit() {
      await this.$store.dispatch("login", {
        params: this.form
      });

      if (this.$store.state.sys.sysUser.get.id) {
        this.$router.push("/");
      } else {
        this.$message.error("账号或密码错误，请重新输入！");
      }
    }
  }
};
</script>

<style lang="less">
.login {
  .el-card__body {
    padding: 0;
  }
  .el-form-item__content {
    .el-button--primary {
      width: 100%;
      background: rgba(27, 153, 79, 1);
      box-shadow: 0px 7px 16px 0px rgba(54, 179, 33, 0.5);
      border-radius: 3px;
    }
  }
  .el-form-item__label {
    min-height: 40px;
  }
}
</style>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: #f7faf8;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  .box-card {
    width: 850px;
    height: 510px;

    img {
      width: 517px;
      height: 510px;

      display: inline-block;
    }

    form {
      width: 240px;

      padding: 46px;

      display: inline-block;

      vertical-align: top;
    }
  }
}
</style>
